import { render, staticRenderFns } from "./RadioButtonCards.vue?vue&type=template&id=210f5b2c&scoped=true&"
import script from "./RadioButtonCards.vue?vue&type=script&lang=js&"
export * from "./RadioButtonCards.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonCards.vue?vue&type=style&index=0&id=210f5b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f5b2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
